<div class = "ui-modal">
    <i [ngClass] = "{
        'ui-icon-success': !data.isError && !data.isConfirmation,
        'ui-icon-danger': data.isError,
        'ui-icon-warning': data.isConfirmation
    }" [class] = "'ui-message-icon ' + data.icon"></i>
    <span class = "ui-bold-message">{{ data.boldMessage }}</span>
    <span class = "ui-message" [innerHtml]="data.message"></span>
    <span *ngIf = "data.subMessage" class = "ui-sub-message" [innerHtml]="data.subMessage"></span>
    <button *ngIf = "data.link !== undefined" class = "ui-text-button ui-button-link" (click) = "eventFollowLink()">{{ data.linkMessage }}</button>
    <div class = "ui-dialog-actions" *ngIf = "!data.isConfirmation">
        <button matTooltip = "Tentar Novamente" class = "ui-circle-button" *ngIf = "data.canRefresh" (click) = "eventRefresh()">
            <i class = "ui-icon ui-danger-icon uii-repeat"></i>
        </button>
    </div>
    <div class = "ui-dialog-actions" *ngIf = "data.isConfirmation">
        <button class = "ui-button" (click) = "eventConfirmation(true)">
            Sim
        </button>
        <button class = "ui-button" (click) = "eventConfirmation(false)">
            Não
        </button>
    </div>
</div>
